export const PHIVE_RET = {
    NETWORK: -1,
    CERT: -2,
    CORRUPT: -3,
    NOMEM: -4,
    UNSUPP: -5,
    VERMIS: -6,
    ALVER: -7,
    FORMAT: -8,
    SYSMODE: -9,
    AUTH: -10,
    NA: -11,
    BUSY: -12,
    BADV: -13,
    TOKEN: -14,
    CFG: -15,
    OID: -16,
    UEXIST: -17,
    DEXIST: -18,
    TMOUT: -19,
    POINTID: -20
  };